import * as actionType from './types';
import axios from '../../../common/config/axios';

export const getList = (props) => dispatch => 
{
    axios.get('reject_reason/list', {params: props})
    .then(function (response) 
    {
      dispatch (
      {
        type: actionType.LIST,
        value: response.data
      })
    })
    .catch(err => 
    {
      
    });
};

export const getDropDown = () => dispatch =>
{
    axios.get('reject_reason/drop_down')
    .then(function (response)
    {
      dispatch (
      {
        type: actionType.DROPDOWN,
        value: response.data
      })
    })
    .catch(err =>
    {

    });
};

export const store = (data) => dispatch =>
{
    // console.log(data);
    axios.post('reject_reason/store', data)
    .then(function (response) 
    {
      dispatch (
      {
        type: actionType.STORE,
        value: response.data
      })
    })
    .catch(err => 
    {
      
    });
};

export const getDetails = (id) => dispatch =>
{   
    if(id > 0)
    {
      axios.get('reject_reason/details',{
        params: {
            "id": id,
        }
      })
      .then(function (response) 
      {
        dispatch (
        {
          type: actionType.DETAILS,
          value: response.data
        })
      })
      .catch(function (error) 
      {
        
      });
    }
};

export const update = (data) => dispatch =>
{
    // console.log(data);
    axios.post('reject_reason/update', data)
    .then(function (response) 
    {
      dispatch (
      {
        type: actionType.UPDATE,
        value: response.data
      })
    })
    .catch(err => 
    {
      
    });
};

export const deleteData = (data) => dispatch =>
{
    // console.log(data);
    axios.post('reject_reason/delete', data)
    .then(function (response) 
    {
      dispatch (
      {
        type: actionType.DELETE,
        value: response.data
      })
    })
    .catch(err => 
    {
      
    });
};